export const queryKeys = {
  authQueryKeys: {
    login: ["login"],
    userDetail: ["USER_PROFILE"],
    forgotPassword: ["FORGOT_PASSWORD"],
    resendOtp: ["RESEND_OTP"],
    verifyOtp: ["VERIFY_OTP"],
    resetPassword: ["RESET_PASSWORD"],
  },
  changePassword: ["CHANGE_PASSWORD"],
  dashboard: {
    stats: "DASHBOARD_STATS",
    bookingStatusDistribution: "DASHBOARD_BOOKING_STATUS_DISTRIBUTION",
    revenueGraph: "DASHBOARD_REVENUE_GRAPH",
    userListeningGraph: "DASHBOARD_USER_LISTENING_GRAPH",
    storyMethods: "DASHBOARD_STORY_METHODS",
    voiceClones: "DASHBOARD_VOICE_CLONES",
  },
  userManagement: {
    listing: "USER_LISTING",
    delete: "USER_DELETE",
    statusUpdate: "UPDATE_STATUS",
    details: "USER_DETAILS",
    stats: "USER_STATS",
    profile: "USER_PROFILE",
    toggleCustomerStatus: "CUSTOMER_TOGGLE_STATUS",
  },
  driverManagement: {
    listing: "DRIVER_LISTING",
    details: "DRIVER_DETAILS",
    create: "DRIVER_CREATE",
    update: "DRIVER_UPDATE",
    delete: "DRIVER_DELETE",
    assignVehicle: "DRIVER_ASSIGN_VEHICLE",
    toggleBlock: "DRIVER_TOGGLE_BLOCK",
    revokeInvite: "DRIVER_REVOKE_INVITE",
    restoreInvite: "DRIVER_RESTORE_INVITE",
    markInactive: "DRIVER_MARK_INACTIVE",
    phoneChangeRequest: "DRIVER_PHONE_CHANGE_REQUEST",
    approvePhoneChange: "DRIVER_APPROVE_PHONE_CHANGE",
    rejectPhoneChange: "DRIVER_REJECT_PHONE_CHANGE",
  },
  bookingManagement: {
    listing: "BOOKING_LISTING",
    details: "BOOKING_DETAILS",
    cancel: "BOOKING_CANCEL",
  },
  pricingManagement: {
    listing: "PRICING_RULES_LISTING",
    create: "PRICING_RULE_CREATE",
    update: "PRICING_RULE_UPDATE",
    delete: "PRICING_RULE_DELETE",
    settings: "PLATFORM_SETTINGS",
    updateSettings: "PLATFORM_SETTINGS_UPDATE",
  },
  vehicleManagement: {
    listing: "VEHICLE_LISTING",
    details: "VEHICLE_DETAILS",
    create: "VEHICLE_CREATE",
    update: "VEHICLE_UPDATE",
    delete: "VEHICLE_DELETE",
    assignDriver: "VEHICLE_ASSIGN_DRIVER",
    updateStatus: "VEHICLE_UPDATE_STATUS",
  },
  lookups: {
    allUsers: "ALL_USERS",
    categories: "CATEGORIES",
    cities: "CITIES",
    vehicles: "VEHICLES",
  },
};
